'use client';

import { SortControl } from '../../Sort/SortControl';
import { useSearchV2Sort } from '../hooks/useSearchV2Sort';
import { SortProps } from './Sort.types';

export const Sort = ({ className }: SortProps) => {
  const { currentSortValue, sortCriteria, handleSort, isReady } =
    useSearchV2Sort();

  return (
    <SortControl
      currentSortValue={currentSortValue}
      sortCriteria={sortCriteria}
      onSort={handleSort}
      className={className}
      disabled={!isReady}
    />
  );
};
